export default "<p>\n  root-dashboard works!\n</p>\n";